import { createAsyncThunk } from '@reduxjs/toolkit';

import { updateBusinessProductStatuses } from 'pages/dashboard/components/Progress/thunks';
import { submitBusinessApplication } from 'services/businesses';
import { fetchProfileByEmail } from 'pages/Profile/thunks';
import { onboardingOatFi } from 'services/integrations';
import { getProfile } from 'pages/Profile/selectors';
import { ProductStatuses } from 'entities/progress';
import { getTenant } from 'theme/selectors';
import { RootState } from 'state/store';

export const submitApplication: any = createAsyncThunk(
  'submitDashboard/submitApplication',
  async (_: void, thunks) => {
    try {
      const { getState, dispatch } = thunks;

      const state = getState() as RootState;

      const { business, person } = getProfile(state);
      const tenant = getTenant(state);

      await submitBusinessApplication({
        businessesId: business.businessesId,
        modifiedBy: person.emailAddress,
        fromEmailId: tenant.supportEmailAddress,
        tenantsId: tenant.tenantsId,
      });

      dispatch(updateBusinessProductStatuses(ProductStatuses.pendingApproval));

      await dispatch(fetchProfileByEmail(person.emailAddress));

      return true;
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export const oatFiOnboarding: any = createAsyncThunk(
  'submitDashboard/oatFiOnboarding',
  async (_: void, thunks) => {
    try {
      const { getState, dispatch } = thunks;

      const { business, person } = getProfile(getState() as RootState);

      let externalId: string | null = null;

      try {
        externalId = await onboardingOatFi({
          businessesId: business.businessesId,
          modifiedBy: person.emailAddress,
        });
      } catch {
        return null;
      }

      dispatch(fetchProfileByEmail(person.emailAddress));

      return externalId;
    } catch (e) {
      return Promise.reject(e);
    }
  },
);
